import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { operations } from '@luxuryescapes/contract-svc-promo/generated';

import { checkChannelMarkupV2 } from '~/services/PromoService';

import { normalizeResponseWarnings } from './useChannelMarkupV2';
import { channelMarkupV2QueryKeys } from './useGetChannelMarkupV2ById';

type CheckPayload = operations['checkChannelMarkupV2']['requestBody']['content']['application/json'];

type CheckResult = {
  canSave: boolean;
  warnings: Array<string>;
};

type Params = {
  payload: CheckPayload;
  enabled?: boolean;
};

export function useCheckChannelMarkupV2({ payload, enabled = true }: Params) {
  return useQuery<CheckResult>({
    queryKey: channelMarkupV2QueryKeys.check(payload),
    queryFn: async () => {
      const response = await checkChannelMarkupV2(payload);
      return {
        canSave: Boolean(response.result?.canSave),
        warnings: normalizeResponseWarnings(response),
      };
    },
    enabled,
    // Keep the previous result visible while the next check runs so canSave/warnings don't
    // flash empty between edits. Keying by payload also means an out-of-order response for a
    // superseded payload is cached under its own key, never rendered.
    placeholderData: keepPreviousData,
  });
}
